import Nullstack from 'nullstack';
export default function IconFileZip({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-file-zip",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 20.735a2 2 0 0 1 -1 -1.735v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1"
  }), "   ", Nullstack.element("path", {
    d: "M11 17a2 2 0 0 1 2 2v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a2 2 0 0 1 2 -2z"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "5",
    x2: "10",
    y2: "5"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "7",
    x2: "12",
    y2: "7"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "9",
    x2: "10",
    y2: "9"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "11",
    x2: "12",
    y2: "11"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "13",
    x2: "10",
    y2: "13"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "15",
    x2: "12",
    y2: "15"
  }), " ");
}